import React, { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import useTranslation from '../../../hooks/useTranslation'
import { GlobalEquipmentSearchResult, EquipmentGlobalSearchResultType } from '../../../entities/GlobalEquipmentSearchResult'
import urlifyGroupName from '../../../helpers/urlifyGroupName'
import style from './equipmentSearchDropdownOption.css'

export type Props = {
    result: GlobalEquipmentSearchResult
    onSelect: (result: GlobalEquipmentSearchResult) => void
}

const EquipmentSearchDropdownOption: FunctionComponent<Props> = (props) => {
    const { result, onSelect } = props
    const { t } = useTranslation()
    const history = useHistory()

    const currentPath = history.location.pathname
    const resultPath = urlifyGroupName(result.equipmentGroupId)
    const isCurrentPage = currentPath.includes(resultPath) || currentPath === `/${resultPath}`

    const handleClick = () => {
        onSelect(result)
    }

    return (
        <div
            className={style.option}
            onClick={handleClick}
        >
            <div className={style.optionHeader}>
                <span className={style.optionName}>
                    {result.equipmentName}
                </span>
                <span className={style.prNumberBadge}>
                    {result.equipmentEvaKey || ''}
                </span>
            </div>
            <div className={style.optionMetadata}>
                <div className={style.pageLocation}>
                    {isCurrentPage ? (
                        <div className={`${style.pageIndicator} ${style.pageIndicatorCurrent}`}></div>
                    ) : (
                        <span className={style.arrowIcon}></span>
                    )}
                    <span className={`${style.pageLocationText} ${isCurrentPage ? style.pageLocationTextCurrent : style.pageLocationTextOther}`}>
                        {t(`navigation.${result.equipmentGroupId}`) !== `navigation.${result.equipmentGroupId}`
                            ? t(`navigation.${result.equipmentGroupId}`)
                            : result.equipmentGroupId}
                    </span>
                </div>
                {result.equipmentFamilyName && (
                    <div className={style.familySection}>
                        <span className={style.familyLabel}>
                            {t('equipmentGlobalSearch.areaLabel')}
                        </span>
                        <span className={style.familyName}>
                            {result.equipmentFamilyName}
                        </span>
                    </div>
                )}
                {result.type === EquipmentGlobalSearchResultType.PACKAGE_CONTENT && result.packageParentId && (
                    <div className={style.packageSection}>
                        <span className={style.packageText}>
                            {t('equipmentGlobalSearch.containedInPackageLabel')}
                        </span>
                        <span className={style.packageParent}>
                            {result.packageParentId}
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}

export default EquipmentSearchDropdownOption
